// extracted by mini-css-extract-plugin
export default {"featureImage":"featureImage__9NE5H","container":"container__DkaTb","youtubeLink":"youtubeLink__lmMNn"};